import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted';
import { useDispatch, useSelector } from 'react-redux';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import {
    actualizarFC_08PaginaActiva, ObtenerClientePorLogin08, obtenerContadorDeFechaFolio,
    actualizarFC_08Solicitud,
    setCambiosFC_08SolicitudBorrador, setCambiosFC_08SolicitudNueva,
    agregarFC_08Accion, actualizarFC_08Estatus,
    resetDataFC_08,
    eliminarFC_08AnexoProductoBD,
    actualizarModoBorradorFC_08,
    agregarFC_08AnexoCertificado,
    actualizarModoCorrecionFC_08, agregarInstalacionesFiltro
} from '../../../redux/DucksBeneficiario/FC_08Ducks';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
const { useState, useEffect, useRef } = React;
import TablaProducto from './TablaProducto';
import estilos from '../FormularioFC08/FormularioFC08BeneficiarioComponent.module.css'
import InfoBar from '../../App/InfoBar'
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { Formik } from 'formik'
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import DocumentacionFC_08Component from './DocumentacionFC_08Component';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC08BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)

    let dataCliente = useSelector(store => store.FC_08Solicitud.cliente)
    let dataLogin = useSelector(store => store.FC_08Solicitud.dataLogin)
    let instalacionesCliente = useSelector(store => store.FC_08Solicitud.instalacionesFiltro)
    let instalacionesData = useSelector(store => store.FC_08Solicitud.instalacionesCliente)
    var fechaHoy = moment().format('YYYY-MM-DD')
    const idUsuario = usuario.data.user[0].id
    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const currentUser = useSelector(store => store.Usuario.data)
    const idlogin = idUsuario

    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin08({ idlogin: usuario.data.user[0].id }))
    }, [])


    let fc_08 = useSelector(store => store.FC_08Solicitud.fc_08)
    let fc_08Certificados = useSelector(store => store.FC_08Solicitud.certificados)
    let fc_08Map = useSelector(store => store.FC_08Solicitud.fc_08Map)
    let fc_08CertificadosMap = useSelector(store => store.FC_08Solicitud.certificadosMap)
    const modoEdicionBorrador = useSelector(store => store.FC_08Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_08Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_08Solicitud.data)

    const store = useSelector(store => store)

    const handleResetAllPropertys = () => {
        setcertificados([])
        dispatch(resetDataFC_08())
        handleCloseModal()
    }

    const noActualizarBorrador = useRef(true)
    React.useEffect(() => {

        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_08 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_08))) {

        }
    }, [fc_08, data])

    React.useEffect(() => {
        if (fc_08Certificados.length > 0) {
            setcertificados(fc_08Certificados)
        }
    }, [])

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()

    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_08':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'enviarSolicitudBorradorFC_08':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const botonEnviarSolicitudFC_08 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_08'
        })
    }

    const botonEnviarBorradorFC_08 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar su solicitud al personal de atención al cliente, 
            ya no podrá seguir editando esta solicitud.`,
            accion: 'enviarBorrador'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_08 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    const botonEnviarSolicitudBorradorFC_08 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_08'
        })
    }
    const botonRegistrarFC_08 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio
        const solicitud = {
            numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial, fechasolicitud: fechaSolicitud,
            tipoinstalacion: valores.tipoinstalacion, nombreresponsable: valores.nombreresponsable,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono,
            domicilio: valores.domicilio,
            idestatusdesolicitudes: 7, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const objetoCompletoFC_08 = {
            solicitud,
            certificados,
        }
        const resultado = await dispatch(agregarFC_08Accion(objetoCompletoFC_08))
        await dispatch(actualizarLoadingApp_false())
        await dispatch(resetDataFC_08())
        functionResetForm.function()
        await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')

    }

    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy)?.toISOString()

        const solicitud = {
            idfc08_renvacioncertificado: data.idfc08_renvacioncertificado,
            nombrerazonsocial: dataCliente.nombrerazonsocial, fechasolicitud: fechaSolicitud,
            tipoinstalacion: valores.tipoinstalacion, nombreresponsable: valores.nombreresponsable,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono,
            domicilio: valores.domicilio,
            idestatusdesolicitudes: 5, idlogin: idlogin,
        }
        const objetoCompletoFC_08 = {
            solicitud,
            certificados,
        }
        await dispatch(actualizarFC_08Solicitud(objetoCompletoFC_08))
        const idSolicitud = data.idfc08_renvacioncertificado
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_08 = 3
        const tabla = tablaFC_08
        await dispatch(actualizarFC_08Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_08())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial, fechasolicitud: fechaSolicitud,
            tipoinstalacion: valores.tipoinstalacion, nombreresponsable: valores.nombreresponsable,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono,
            domicilio: valores.domicilio,
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }
        const objetoCompletoFC_08 = {
            solicitud,
            certificados,
        }
        const resultado = await dispatch(agregarFC_08Accion(objetoCompletoFC_08))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_08())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        const solicitud = {
            idfc08_renvacioncertificado: data.idfc08_renvacioncertificado,
            nombrerazonsocial: dataCliente.nombrerazonsocial, fechasolicitud: fechaSolicitud,
            tipoinstalacion: valores.tipoinstalacion, nombreresponsable: valores.nombreresponsable,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono,
            domicilio: valores.domicilio,
            idestatusdesolicitudes: 1, idlogin: idlogin,
        }
        const objetoCompletoFC_08 = {
            solicitud,
            certificados,
        }
        const resultado = await dispatch(actualizarFC_08Solicitud(objetoCompletoFC_08))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_08())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechaHoy).toISOString()

        const solicitud = {
            idfc08_renvacioncertificado: data.idfc08_renvacioncertificado,
            nombrerazonsocial: dataCliente.nombrerazonsocial, fechasolicitud: fechaSolicitud,
            tipoinstalacion: valores.tipoinstalacion, nombreresponsable: valores.nombreresponsable,
            correoelectronico: valores.correoelectronico, telefono: valores.telefono,
            domicilio: valores.domicilio,
            idestatusdesolicitudes: 7, idlogin: idlogin,
        }
        const objetoCompletoFC_08 = {
            solicitud,
            certificados
        }
        const resultado = await dispatch(actualizarFC_08Solicitud(objetoCompletoFC_08))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc08_renvacioncertificado
            const estatusNuevo = 7
            const idCliente = null
            const tablaFC_08 = 3
            const tabla = tablaFC_08
            await dispatch(actualizarFC_08Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_08())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const paginaActiva = useSelector(store => store.FC_08Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            dispatch(actualizarFC_08PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_08PaginaActiva(paginaActiva - 1))
    }
    const [certificados, setcertificados] = React.useState([])
    const handdleCertificado = (objectProducto) => {
        setcertificados(prev => [...prev, objectProducto])
    }
    const handdleRemovecertificadosPrev = async (objectProducto) => {
        if (objectProducto.data.idfc08_anexorenovacion) {
            await dispatch(eliminarFC_08AnexoProductoBD(objectProducto.data.idfc08_anexorenovacion))
        }
        let filtro = certificados?.filter(anexo => anexo.id !== objectProducto.data.id)
        setcertificados(filtro)

    }
    const handdleEditcertificadosPrev = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_08CertificadosMap.length > 0) {
            const filtro = certificados.findIndex(anexo => anexo.idfc08_anexorenovacion === objectProducto.id)
            let editar = { ...certificados[Number(filtro)] }
            const filtroEliminar = certificados.filter(anexo => anexo.idfc08_anexorenovacion !== objectProducto.id)

            editar.numerocertificado = objectProducto.numerocertificado
            editar.tipocertificado = objectProducto.tipocertificado
            editar.vencimientocertificado = objectProducto.vencimientocertificado
            editar.cambioaduana = objectProducto.cambioaduana
            editar.especificaraduana = objectProducto.especificaraduana
            editar.cambiocatidad = objectProducto.cambiocatidad
            editar.especificarcantidad = objectProducto.especificarcantidad
            editar.cambiodestinatario = objectProducto.cambiodestinatario
            editar.especificardestinatario = objectProducto.especificardestinatario
            editar.domicilioimportador = objectProducto.domicilioimportador
            editar.especificardomicilio = objectProducto.especificardomicilio
            editar.otros = objectProducto.otros
            editar.especificarotros = objectProducto.especificarotros
            filtroEliminar.push(editar)
            setcertificados(filtroEliminar)
        } else {
            const filtro = certificados.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = certificados
            const newcertificados = []
            for (const i in certificados) {
                const { ...restProducto } = certificados[i]
                newcertificados.push(restProducto)
            }
            newcertificados[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newcertificados[Number(filtro)].tipocertificado = objectProducto.tipocertificado
            newcertificados[Number(filtro)].vencimientocertificado = objectProducto.vencimientocertificado
            newcertificados[Number(filtro)].cambioaduana = objectProducto.cambioaduana
            newcertificados[Number(filtro)].especificaraduana = objectProducto.especificaraduana
            newcertificados[Number(filtro)].cambiocatidad = objectProducto.cambiocatidad
            newcertificados[Number(filtro)].especificarcantidad = objectProducto.especificarcantidad
            newcertificados[Number(filtro)].cambiodestinatario = objectProducto.cambiodestinatario
            newcertificados[Number(filtro)].especificardestinatario = objectProducto.especificardestinatario
            newcertificados[Number(filtro)].domicilioimportador = objectProducto.domicilioimportador
            newcertificados[Number(filtro)].especificardomicilio = objectProducto.especificardomicilio
            newcertificados[Number(filtro)].otros = objectProducto.otros
            newcertificados[Number(filtro)].especificarotros = objectProducto.especificarotros
            setcertificados(newcertificados)
        }
    }
    const setDatos = (target) => {
        if (target === 'Domicilio Fiscal') {
            const telefono = dataCliente.telefonorepresentante
            const correoelectronico = dataCliente.correoelectronicorepresentante
            const nombreresponsable = dataCliente.nombrerepresentantelegal
            let numeroint = ''
            let numeroext = ''
            if (instalacionesCliente[0].numerointerior === null || instalacionesCliente[0].numerointerior === undefined
                || instalacionesCliente[0].numerointerior === '') numeroint = 's/n'
            else { numeroint = instalacionesCliente[0].numerointerior }
            if (instalacionesCliente[0].numeroexterior === null || instalacionesCliente[0].numeroexterior === undefined
                || instalacionesCliente[0].numeroexterior === '') numeroext = 's/n'
            else { numeroext = instalacionesCliente[0].numeroexterior }
            const domicilio = instalacionesCliente[0].calle + ',' + numeroint + ',' + numeroext + ',' +
                instalacionesCliente[0].colonia + ',' + instalacionesCliente[0].localidad + ',' + instalacionesCliente[0].municipioalcaldia + ',' +
                instalacionesCliente[0].estado + ',' + instalacionesCliente[0].codigopostal
            return { nombreresponsable, telefono, correoelectronico, domicilio }
        } else {
            for (let dato in instalacionesCliente) {
                if (instalacionesCliente?.[dato]?.informaciongeneralinstalacioncliente?.alias === target) {
                    const telefono = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].telefono
                    const correoelectronico = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].correoelectronico
                    const nombreresponsable = instalacionesCliente[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0].nombreresponsable
                    let numeroint = ''
                    let numeroext = ''
                    if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === null ||
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === undefined ||
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior === '') numeroint = 's/n'
                    else { numeroint = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numerointerior }
                    if (instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === null ||
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === undefined ||
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior === '') numeroext = 's/n'
                    else { numeroext = instalacionesCliente[dato].informaciongeneralinstalacioncliente.numeroexterior }
                    const domicilio = instalacionesCliente[dato].informaciongeneralinstalacioncliente.calle + ',' +
                        numeroint + ',' + numeroext + ',' +
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.colonia + ',' +
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.localidad + ',' +
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.municipio + ',' +
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.estado + ',' +
                        instalacionesCliente[dato].informaciongeneralinstalacioncliente.codigopostal
                    return { nombreresponsable, telefono, correoelectronico, domicilio }
                }
            }
        }
        return ''
    }
    const validation = async values => {
        let errores = {};
        const textoError = 'Campo obligratorio'

        if (paginaActiva === 1) {
            if (!values.tipoinstalacion) { errores.tipoinstalacion = textoError }
            if (!values.nombreresponsable) { errores.nombreresponsable = textoError }
            if (!values.correoelectronico) { errores.correoelectronico = textoError }
            if (!values.telefono) { errores.telefono = textoError }
            if (!values.domicilio) { errores.domicilio = textoError }
            if (certificados.length <= 0) { errores.certificados = 'Debe de ingresar por lo menos un certificado a renovar' }
            await instalaciones()
        }
        /*if (paginaActiva === 2) {
            if (!values.vencimientocertificado && !values.cambioaduana && !values.cambiocatidad
                && !values.cambiodestinatario && !values.domicilioimportador && !values.otros) { errores.opcionesCheck = 'Seleccionar una opción' }
            if (values.cambioaduana) {
                if (!values.especificaraduana) { errores.especificaraduana = textoError }
            }
            if (values.cambiocatidad) {
                if (!values.especificarcantidad) { errores.especificarcantidad = textoError }
            }
            if (values.cambiodestinatario) {
                if (!values.especificardestinatario) { errores.especificardestinatario = textoError }
            }
            if (values.domicilioimportador) {
                if (!values.especificardomicilio) { errores.especificardomicilio = textoError }
            }
            if (values.otros) {
                if (!values.especificarotros) { errores.especificarotros = textoError }
            }
        }*/
        return errores;
    }
    const instalaciones = async () => {
        let granel = certificados?.filter(anexo => anexo?.tipocertificado == 'Granel')
        let exportacion = certificados?.filter(anexo => anexo?.tipocertificado == 'Exportacion')
        let promocion = certificados?.filter(anexo => anexo?.tipocertificado == 'Exportacion promocion')
        if ((exportacion.length > 0 || promocion.length > 0)) {
            let nuevasInstalaciones = []
            for (const i in instalacionesData) {
                let { ...data } = instalacionesData[i]
                if (data.iddomiciliofiscal != null && data.iddomiciliofiscal != undefined) {
                    nuevasInstalaciones.push(data)
                }
            }
            await dispatch(agregarInstalacionesFiltro(nuevasInstalaciones))
        }
        if (granel.length > 0) {
            let nuevasInstalaciones = []
            for (const i in instalacionesData) {
                let { ...data } = instalacionesData[i]
                if (data.iddomiciliofiscal == null && data.iddomiciliofiscal == undefined) {
                    nuevasInstalaciones.push(data)
                }
            }
            await dispatch(agregarInstalacionesFiltro(nuevasInstalaciones))
        }
        if (granel.length == 0 && exportacion.length == 0 && promocion.length == 0) {
            await dispatch(agregarInstalacionesFiltro([]))
        }
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_08
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_08(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                }}>
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de renovación de certificados'} />
                                </div>
                                <div className='row'>

                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                    botonGuardarComoBorrador(values)}
                                            >
                                                <SaveIcon />
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar cambios en borrador
                                                        </div>) : (
                                                        <div className="badge text-dark textoNormal textoModal">
                                                            Guardar como borrador
                                                        </div>
                                                    )
                                                }
                                            </IconButton>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 text-center marginsitoTop">
                                        <h1></h1>
                                    </div>
                                    {
                                        !modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() => { botonReiniciarFormato(), setFunctionResetForm({ function: resetForm }) }}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                </div>
                            </div>

                            {paginaActiva === 1 ?
                                <Fragment>
                                    <div className='row'>
                                        <h6 className={`text-center ${estilos.labelNaranja}`}>RENOVACIÓN DE CERTIFICADOS NOM</h6>
                                    </div>
                                    <TablaProducto api={{ handdleCertificado, handdleRemovecertificadosPrev, handdleEditcertificadosPrev, certificados }} certificadosMap={fc_08CertificadosMap}></TablaProducto>
                                    {errors.certificados && <div className="text-danger text-center">{errors.certificados}</div>}<br />
                                    <div className='row'>
                                        <h6 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN DEL SOLICITANTE</h6>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-6">
                                                <select className={`form-select ${fc_08Map.tipoinstalacioncheck !== undefined ?
                                                    (fc_08Map?.tipoinstalacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    name="tipoinstalacion"
                                                    value={values.tipoinstalacion}
                                                    onChange={e => {
                                                        const result = setDatos(e.target.value)
                                                        const { ...newValues } = values
                                                        newValues.tipoinstalacion = e.target.value
                                                        if (result !== '') {
                                                            newValues.nombreresponsable = result.nombreresponsable
                                                            newValues.correoelectronico = result.correoelectronico
                                                            newValues.telefono = result.telefono
                                                            newValues.domicilio = result.domicilio
                                                        }
                                                        setValues(newValues)
                                                    }}
                                                    onBlur={handleBlur} >
                                                    <option value="">Tipo de Instalación</option>
                                                    {
                                                        instalacionesCliente?.map((opcion, index) => (
                                                            <option value={`${opcion.idtipoanexo === 1 ? opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? opcion.informaciongeneralinstalacioncliente.alias : 'Domicilio Fiscal'}`} >
                                                                {`${opcion.idtipoanexo === 1 ? 'Unidad Producción' : opcion.idtipoanexo === 2 ? 'Unidad Envasado' : opcion.idtipoanexo === 3 ? 'Unidad Almacén' : 'Domicilio Fiscal'}`}</option>
                                                        ))
                                                    }
                                                </select>
                                                <label htmlFor='floatingInput'>Seleccione una instalación</label>
                                                <span className='text-danger'>{fc_08Map?.tipoinstalacioncheck === true ? fc_08Map?.tipoinstalacion : ''}</span>
                                                {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                            <div className="form-floating mb-6">
                                                <input type="text" className={`form-control ${fc_08Map.nombreresponsablecheck !== undefined ? (
                                                    fc_08Map?.nombreresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="nombreresponsable"
                                                    value={values.nombreresponsable}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />

                                                <label htmlFor='floatingInput'>Nombre de responsable</label>
                                                <span className='text-danger'>{fc_08Map?.nombreresponsablecheck ? fc_08Map?.nombreresponsable : ''}</span>
                                                {touched.nombreresponsable && errors.nombreresponsable && <div className="text-danger">{errors.nombreresponsable}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-4'>
                                            <div className="form-floating mb-6">
                                                <input type="text" className={`form-control ${fc_08Map.correoelectronicocheck !== undefined ? (
                                                    fc_08Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='responsable'
                                                    name="correoelectronico"
                                                    value={values.correoelectronico}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Correo Electrónico</label>
                                                <span className='text-danger'>{fc_08Map?.correoelectronicocheck ? fc_08Map?.correoelectronico : ''}</span>
                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-4 '>
                                            <div className="form-floating mb-6">
                                                <input type="text" className={`form-control ${fc_08Map.telefonocheck !== undefined ? (
                                                    fc_08Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='telefono'
                                                    name="telefono"
                                                    value={values.telefono}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Teléfono</label>
                                                <span className='text-danger'>{fc_08Map?.telefonocheck ? fc_08Map?.telefono : ''}</span>
                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                            </div>
                                        </div>
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4'>
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control ${fc_08Map.domiciliocheck !== undefined ? (
                                                    fc_08Map?.domiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='domicilio'
                                                    name="domicilio"
                                                    value={values.domicilio}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <label htmlFor='floatingInput'>Domicilio completo</label>
                                                <span className='text-danger'>{fc_08Map?.domiciliocheck ? fc_08Map?.domicilio : ''}</span>
                                                {touched.domicilio && errors.domicilio && <div className="text-danger">{errors.domicilio}</div>}
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    {
                                        modoCorreccion &&
                                        <div className={`${estilos.componenteDocFC_08} col-md-12`}>
                                            <DocumentacionFC_08Component> </DocumentacionFC_08Component>
                                        </div>
                                    }
                                    <div className=" text-align: justify">
                                        <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_08'} />
                                    </div>
                                    <br />
                                    {
                                        !modoCorreccion ?
                                            <div>
                                                <div className="row mt-4">
                                                    {
                                                        modoEdicionBorrador ? (
                                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                                <button type="submit"
                                                                    onClick={() => { botonEnviarSolicitudBorradorFC_08(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                    className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                    disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                                <button type="submit"
                                                                    onClick={() => { botonEnviarSolicitudFC_08(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                    className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                    disabled={!terminosYCondiciones}>Enviar</button>
                                                            </div>
                                                        )
                                                    }

                                                </div>
                                            </div> :
                                            <div className="row mt-4">
                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                    <button type="submit"
                                                        onClick={() => { botonEnviarCorreccionesFC_08(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                        className={`btn ${estilos.botonNaranjaRedondo}`}>Enviar correcciones</button>
                                                </div>
                                            </div>
                                    } <br />
                                </Fragment>
                            }
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                        </div>
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}

export default withRouter(FormularioFC08BeneficiarioComponent)
